var React = require('react');

function MediumInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("rect",{"className":"fill","width":"30","height":"30","rx":"5","key":0}),React.createElement("path",{"fill":"#130D41","d":"M10.984 23.202l-2.719-3.225-2.56 3.225zM5.848 7.903h5.717l4.558 9.773-2.176 5.59-5.352-11.872zM18.708 12.175L20.3 7.708h4.797l-1.939 2.234v11.135l1.939 2.119h-7.572l1.645-2.119z","key":1})]));
}

MediumInline.defaultProps = {"viewBox":"0 0 30 30"};

module.exports = MediumInline;

MediumInline.default = MediumInline;
